import { render, staticRenderFns } from "./AdditionalPersonalInfo.vue?vue&type=template&id=67fc7443&scoped=true"
import script from "./AdditionalPersonalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalPersonalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fc7443",
  null
  
)

export default component.exports